// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-error .section.section--rich-text .section__body{max-width:100%}.page-error .section.section--rich-text+.section.section--quick-links{margin-top:var(--spacing-3xl)}@media screen and (min-width:769px){.page-error .section.section--rich-text+.section.section--quick-links{margin-top:var(--spacing-5xl)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
